import {withAuthenticator} from '@aws-amplify/ui-react';
import CallsContainer from './comp/CallsContainer';

function App({signOut, user}) {
    return user ? <div className="flex h-screen min-h-0 w-full flex-col bg-gray-100">
        <header className="z-50 w-full border-b border-slate-200 bg-white/90 px-4 py-4 backdrop-blur-sm sm:px-6">
            <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 ring-1 ring-slate-200">
                        <img src="logo512.png" className="h-10 w-10 object-contain" alt="ELi Logo"/>
                    </div>
                    <div className="min-w-0">
                        <div className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">Emergency Location Intelligence</div>
                        <div className="mt-1 text-3xl font-semibold tracking-tight text-slate-800">Demo PSAP</div>
                    </div>
                </div>
                <button
                    className="inline-flex h-11 items-center rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
                    onClick={signOut}>
                    {LogOutIcon}
                    Log Out
                </button>
            </div>
        </header>
        <main className="min-h-0 flex-1 overflow-hidden">
            <CallsContainer/>
        </main>
    </div> : null;
}

export default withAuthenticator(App, {hideSignUp: true});

const LogOutIcon = <svg className="mr-2 h-5 w-5 text-slate-500" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2"
                        stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z"/>
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/>
    <path d="M7 12h14l-3 -3m0 6l3 -3"/>
</svg>;
